import { Component, OnInit } from '@angular/core';
import { ProgressBar } from './progress-bar';
import { Router } from '@angular/router';

@Component({
    selector: 'pw-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
    urlPathElement: string = '';
    isEnded = false;
    urlPathes: ProgressBar[] = [
        {
            urlSegment: 'cartsum',
            matIconText: 'shopping_cart'
        },
        {
            urlSegment: 'contact',
            matIconText: 'account_box'
        },
        {
            urlSegment: 'delivery',
            matIconText: 'commute'
        },
        {
            urlSegment: 'payment',
            matIconText: 'credit_card'
        },
        {
            urlSegment: 'cartsummary',
            matIconText: 'check_circle'
        }
    ];
    index = 0;

    indexTotransparentElement = 0;
    matIconTextToTransparentElement = '';
    constructor(private _router: Router) {}

    ngOnInit(): void {
        this.urlPathElement = window.location.pathname.split('/').pop() as string;
        this.urlPathes.forEach((urlPatheElement, index) => {
            if (this.urlPathElement === urlPatheElement.urlSegment) {
                this.index = index;
            }
        });

    }

    clickToBar(i: number, urlPath: string) {
        if (this.index >= i) {
            this._router.navigateByUrl('/' + urlPath);
        }
    }
}
